var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktop = function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.412.557A1.98 1.98 0 0 0 22 0H2Q1.176 0 .588.557A1.78 1.78 0 0 0 0 1.897v12.897q0 .782.588 1.34.587.557 1.412.557h6.8q0 .45-.2.924a8 8 0 0 1-.4.83q-.2.356-.2.521 0 .309.237.534a.8.8 0 0 0 .563.225h6.4a.8.8 0 0 0 .562-.225.7.7 0 0 0 .238-.534q0-.153-.2-.515a8 8 0 0 1-.4-.842q-.2-.48-.2-.919H22q.825 0 1.412-.556a1.78 1.78 0 0 0 .588-1.34V1.897a1.78 1.78 0 0 0-.588-1.34M22.4 11.76q0 .154-.118.267a.4.4 0 0 1-.282.112H2a.4.4 0 0 1-.281-.112.36.36 0 0 1-.119-.267V1.897q0-.155.119-.267A.4.4 0 0 1 2 1.518h20q.164 0 .282.112t.118.267z"
  })));
};
export default SvgDesktop;